import { useEffect, useState } from "react";
import axios from "axios";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { CheckCircle2, Eye, History, Loader2, PenLine } from "lucide-react";
import { fmtDate } from "./assessmentMeta";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function RevisionHistoryDialog({ assessment, onClose, onView }) {
  const [versions, setVersions] = useState(null);
  useEffect(() => {
    axios.get(`${API}/assessments/${assessment.id}/history`).then((r) => setVersions(r.data.versions || [])).catch(() => setVersions([]));
  }, [assessment.id]);
  const total = assessment.recurring_count || 0;
  const done = (versions || []).filter((v) => v.status === "completed" && v.revision_number > 0).length;

  return (
    <Dialog open onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-md" data-testid="revision-history-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-base"><History className="w-4 h-4 text-sky-600" /> {assessment.template_title} — versions</DialogTitle>
        </DialogHeader>
        <p className="text-xs text-slate-600">{done} of {total} supervisory updates completed{done >= total ? " — cycle complete; start a new form at re-admission." : "."}</p>
        {versions === null ? <div className="flex justify-center py-6"><Loader2 className="w-5 h-5 animate-spin text-slate-400" /></div> : (
          <ol className="divide-y rounded-md border" data-testid="revision-versions">
            {versions.map((v) => (
              <li key={v.id} className="flex items-center gap-3 px-3 py-2 text-sm" data-testid={`revision-version-${v.id}`}>
                {v.status === "completed" ? <CheckCircle2 className="w-4 h-4 text-emerald-600 shrink-0" /> : <PenLine className="w-4 h-4 text-amber-500 shrink-0" />}
                <div className="flex-1 min-w-0">
                  <p className="font-medium text-slate-800">{v.label}</p>
                  <p className="text-[11px] text-slate-500">Visit {fmtDate(v.visit_date)} · {v.completed_by_name || v.rn_name}{v.status !== "completed" && " · in progress"}</p>
                </div>
                {v.status === "completed" ? (
                  <Button size="sm" variant="outline" className="h-7 gap-1 text-xs" onClick={() => onView(v)} data-testid={`revision-view-${v.id}`}><Eye className="w-3 h-3" /> View</Button>
                ) : <Badge className="bg-amber-100 text-amber-800 border-amber-200 text-[10px]">Draft</Badge>}
              </li>
            ))}
          </ol>
        )}
      </DialogContent>
    </Dialog>
  );
}
